import { isTermsEmpty } from '@paintscout/util/builder'
import Form from './TermsForm'
import Section from './TermsSection'
import Thumbnail from './TermsThumbnail'

// `isTermsEmpty` is the section's own empty test, shared with the v2 block
// (`PresentationNext/blocks/Terms`) so the two cannot drift apart. It reads only `quote` and
// `options` off the props the registry hands it.
export default { Form, isEmpty: isTermsEmpty, Section, Thumbnail }
